import React from 'react';
import Joi from 'joi';

import { USER_TYPES } from '../../utils/constants';

import Conditional from '../common/conditional';
import Form from '../common/form';
import Progress from '../themed/progress';

import * as roleService from '../../services/roleService';
import * as toastService from '../../services/toastService';

import * as utils from '../../utils/utilities';
import * as data from '../../utils/data';

class CreateRole extends Form {
	state = {
		data: {
			name: '',
			description: '',
			userType: '',
			manageProjects: false,
			manageUsers: false,
			manageRoles: false,
			manageReports: false,
			reviewReports: false,
			previewAllReports: false,
			approveReports: false,
			viewReports: false,
			viewAssociatedReports: false,
		},
		errors: {},
		loading: false,
		progress: 0,
	};

	schema = {
		name: Joi.string().min(3).required().label('Role Name'),
		description: Joi.string().min(8).required().label('Role Name'),
		userType: Joi.string().min(3).required().label('User Type'),
		manageProjects: Joi.boolean().required().label('Manage Project'),
		manageUsers: Joi.boolean().required().label('Manage Users'),
		manageRoles: Joi.boolean().required().label('Manage Roles'),
		reviewReports: Joi.boolean().required().label('Review Report'),
		approveReports: Joi.boolean().required().label('Approve Report'),
		manageReports: Joi.boolean().required().label('Manage Reports'),
		previewAllReports: Joi.boolean().required().label('Preview All Reports'),
		viewReports: Joi.boolean().required().label('View All Reports'),
		viewAssociatedReports: Joi.boolean()
			.required()
			.label('View Associated Reports'),
	};

	postData = async (): Promise<void> => {
		await roleService.createRole(this.state.data, this.handleProgressChange);
		window.location.reload();
	};

	doSubmit = (): void => {
		toastService.promise(this.postData(), {
			loading: 'Creating Role',
			success: 'Role Created',
			error: utils.getErrorMessage,
		});
	};

	render() {
		return (
			<React.Fragment>
				<Progress progress={this.state.progress} />

				<form autoComplete="off" onSubmit={this.handleSubmit}>
					<h1 className="form-title">Create Role</h1>

					<div className="divider my-3"></div>

					<div className="row">
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'name',
								label: 'Role Name',
								placeholder: 'Enter role name',
							})}
						</div>
						<div className="col">
							{this.renderInput({
								type: 'text',
								name: 'description',
								label: 'Role Description',
								placeholder: 'Enter role description',
							})}
						</div>
						<div className="col">
							{this.renderSelect({
								name: 'userType',
								label: 'User Type',
								placeholder: 'Select User Type',
								options: data.getUserTypes(),
							})}
						</div>
					</div>

					<Conditional isVisible={this.state.data.userType === USER_TYPES.INTERNAL}>
						<React.Fragment>
							<div className="row mt-3">
								<div className="col">
									{this.renderSwitch({
										name: 'manageProjects',
										label: 'Manage Projects',
									})}
								</div>
								<div className="col">
									{this.renderSwitch({
										name: 'manageUsers',
										label: 'Manage Users',
									})}
								</div>
								<div className="col">
									{this.renderSwitch({
										name: 'manageRoles',
										label: 'Manage Roles',
									})}
								</div>
								<div className="col">
									{this.renderSwitch({
										name: 'manageReports',
										label: 'Manage Reports',
									})}
								</div>
							</div>

							<div className="divider my-4"></div>

							<div className="row">
								<div className="col">
									{this.renderSwitch({
										name: 'previewAllReports',
										label: 'Preview All Reports',
									})}
								</div>

								<div className="col">
									{this.renderSwitch({
										name: 'reviewReports',
										label: 'Review Report',
									})}
								</div>

								<div className="col">
									{this.renderSwitch({
										name: 'approveReports',
										label: 'Approve Report',
									})}
								</div>
							</div>
						</React.Fragment>
					</Conditional>

					<Conditional isVisible={this.state.data.userType === 'external user'}>
						<div className="row mt-4">
							<div className="col">
								{this.renderSwitch({
									name: 'viewReports',
									label: 'View All Reports',
								})}
							</div>

							<div className="col">
								{this.renderSwitch({
									name: 'viewAssociatedReports',
									label: 'View Associated Reports Only',
								})}
							</div>
						</div>
					</Conditional>

					<div className="d-flex justify-content-end">
						{this.renderButton('Create Role')}
					</div>
				</form>
			</React.Fragment>
		);
	}
}

export default CreateRole;
